module.exports = __webpack_public_path__ + "f5a08d940f45f6bdcd7fc2d69019e2e2.pdf";